<template>
  <div class="order-payment-panel">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col v-if="!hasFixedOrder" :md="8" :sm="24">
            <a-form-item :label="$t('views.orderPayment.search.orderId')" prop="orderId">
              <a-input
                v-model="queryParam.orderId"
                :placeholder="$t('views.orderPayment.search.orderIdPlaceholder')"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderPayment.search.money')" prop="money">
                <a-input
                  v-model="queryParam.money"
                  :placeholder="$t('views.orderPayment.search.moneyPlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.orderPayment.search.sort')" prop="sort">
                <a-input
                  v-model="queryParam.sort"
                  :placeholder="$t('views.orderPayment.search.sortPlaceholder')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="handleQuery">
                <a-icon type="search" />{{ $t('views.orderPayment.action.query') }}
              </a-button>
<!--              <a-button style="margin-left: 8px" @click="resetQuery">-->
<!--                <a-icon type="redo" />{{ $t('views.orderPayment.action.reset') }}-->
<!--              </a-button>-->
<!--              <a style="margin-left: 8px" @click="toggleAdvanced">-->
<!--                {{ advanced ? $t('views.orderPayment.search.collapse') : $t('views.orderPayment.search.expand') }}-->
<!--                <a-icon :type="advanced ? 'up' : 'down'" />-->
<!--              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operations">
<!--      <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:orderPayment:add']">-->
<!--        <a-icon type="plus" />{{ $t('views.orderPayment.action.add') }}-->
<!--      </a-button>-->
<!--      <a-button-->
<!--        type="primary"-->
<!--        :disabled="single"-->
<!--        @click="$refs.createForm.handleUpdate(undefined, ids)"-->
<!--        v-hasPermi="['user:orderPayment:edit']"-->
<!--      >-->
<!--        <a-icon type="edit" />{{ $t('views.orderPayment.action.edit') }}-->
<!--      </a-button>-->
<!--      <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:orderPayment:remove']">-->
<!--        <a-icon type="delete" />{{ $t('views.orderPayment.action.delete') }}-->
<!--      </a-button>-->
<!--      <table-setting-->
<!--        :style="{float: 'right'}"-->
<!--        :table-size.sync="tableSize"-->
<!--        v-model="columns"-->
<!--        :refresh-loading="loading"-->
<!--        @refresh="getList"-->
<!--      />-->
    </div>
    <create-form
      ref="createForm"
      :preset-order-id="presetOrderIdForForm"
      @ok="onPaymentFormOk"
    />
<!--      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"-->
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"

      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: 'max-content' }"
    >
      <span slot="paymentType" slot-scope="text, record">
        {{ formatPaymentType(record.type) }}
      </span>
      <span slot="url" slot-scope="text, record">
        <template v-if="splitUrlList(record.url).length">
          <img
            v-for="(item, index) in splitUrlList(record.url)"
            :key="index"
            style="width: 48px;height: 48px;margin-right: 5px;margin-bottom: 5px"
            v-image-preview
            :src="item"
          >
        </template>
        <span v-else>—</span>
      </span>
      <span slot="auditStatus" slot-scope="text, record">
        {{ formatAuditStatus(record.auditStatus) }}
      </span>
      <span slot="sort" slot-scope="text, record">
        <a-input-number
          :value="record.sort"
          :min="0"
          style="width: 100px"
          @change="(value) => handleSortChange(record, value, 'sort')"
        />
      </span>
      <span slot="status" slot-scope="text, record">
        <a-switch
          :checked="record.status == 1 || record.status == '1'"
          @change="(checked) => handleStatusChange(record, checked)"
        />
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <template v-if="isAuditPending(record)">
          <a-divider type="vertical" v-hasPermi="['user:orderPayment:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:orderPayment:edit']">
            <a-icon type="audit" />{{ $t('views.orderPayment.action.audit') }}
          </a>
        </template>
<!--        <a-divider type="vertical" v-hasPermi="['user:orderPayment:remove']" />-->
<!--        <a @click="handleDelete(record)" v-hasPermi="['user:orderPayment:remove']">-->
<!--          <a-icon type="delete" />{{ $t('views.orderPayment.action.delete') }}-->
<!--        </a>-->
      </span>
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :show-total="paginationShowTotal"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </div>
</template>

<script>
import { pageOrderPayment, delOrderPayment, updateOrderPayment } from '@/api/user/orderPayment'
import CreateForm from './CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderPaymentPanel',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  props: {
    /** 从商品订单等入口传入时锁定订单 ID，列表仅查该订单且隐藏订单 ID 筛选项 */
    fixedOrderId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        orderId: null,
        type: null,
        money: null,
        url: null,
        auditStatus: null,
        auditReason: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  computed: {
    hasFixedOrder () {
      return this.fixedOrderId !== null && this.fixedOrderId !== undefined && this.fixedOrderId !== ''
    },
    presetOrderIdForForm () {
      return this.hasFixedOrder ? this.fixedOrderId : null
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    },
    fixedOrderId () {
      this.applyFixedOrderQuery()
      this.getList()
    }
  },
  created () {
    this.buildColumns()
    this.applyFixedOrderQuery()
    this.getList()
  },
  methods: {
    /** 审核/新增付款保存成功后：刷新本面板列表，并通知外层（如商品订单页）刷新订单 */
    onPaymentFormOk () {
      this.getList()
      this.$emit('payment-updated')
    },
    applyFixedOrderQuery () {
      if (this.hasFixedOrder) {
        this.queryParam.orderId = this.fixedOrderId
      } else {
        this.queryParam.orderId = null
      }
      this.queryParam.pageNum = 1
    },
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.orderPayment.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        // { title: t('views.orderPayment.column.orderId'), dataIndex: 'orderId', ellipsis: true, align: 'center' },
        {
          title: t('views.orderPayment.column.type'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'paymentType' },
          ellipsis: true,
          align: 'center'
        },
        { title: t('views.orderPayment.column.money'), dataIndex: 'money', ellipsis: true, align: 'center' },
        {
          title: t('views.orderPayment.column.url'),
          dataIndex: 'url',
          scopedSlots: { customRender: 'url' },
          align: 'center'
        },
        {
          title: t('views.orderPayment.column.auditStatus'),
          dataIndex: 'auditStatus',
          scopedSlots: { customRender: 'auditStatus' },
          ellipsis: true,
          align: 'center'
        },
        { title: t('views.orderPayment.column.auditReason'), dataIndex: 'auditReason', ellipsis: true, align: 'center' },
        { title: t('views.orderPayment.column.auditReasonEn'), dataIndex: 'auditReasonEn', ellipsis: true, align: 'center' },
        // {
        //   title: t('views.orderPayment.column.sort'),
        //   dataIndex: 'sort',
        //   scopedSlots: { customRender: 'sort' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: t('views.orderPayment.column.status'),
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: t('views.orderPayment.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.orderPayment.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.orderPayment.pagination.total', { total })
    },
    splitUrlList (url) {
      if (url == null || url === '') {
        return []
      }
      return String(url)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    },
    /** 待审核：auditStatus 为 0 */
    isAuditPending (record) {
      if (!record) {
        return false
      }
      const v = record.auditStatus
      return v === 0 || v === '0'
    },
    formatPaymentType (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const n = Number(value)
      const keyByNum = {
        0: 'views.orderPayment.paymentType.full',
        1: 'views.orderPayment.paymentType.first',
        2: 'views.orderPayment.paymentType.final'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : this.$t('views.orderPayment.paymentType.unknown', { value: String(value) })
    },
    formatAuditStatus (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const n = Number(value)
      const keyByNum = {
        0: 'views.orderPayment.auditStatus.pending',
        1: 'views.orderPayment.auditStatus.approved',
        2: 'views.orderPayment.auditStatus.rejected'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : this.$t('views.orderPayment.auditStatus.unknown', { value: String(value) })
    },
    getList () {
      this.loading = true
      pageOrderPayment(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      const pageSize = this.queryParam.pageSize
      this.queryParam = {
        orderId: this.hasFixedOrder ? this.fixedOrderId : undefined,
        type: undefined,
        money: undefined,
        url: undefined,
        auditStatus: undefined,
        auditReason: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      const that = this
      const ids = row && row.id != null && row.id !== undefined ? [row.id] : [...this.ids].filter(id => id != null)
      if (!ids.length) {
        return
      }
      this.$confirm({
        title: this.$t('views.orderPayment.confirm.deleteTitle'),
        content: this.$t('views.orderPayment.confirm.deleteContent', { ids: ids.join(', ') }),
        onOk () {
          const data = ids.map(id => ({ id }))
          return delOrderPayment(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('views.orderPayment.msg.deleteOk'), 3)
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateOrderPayment(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.orderPayment.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.orderPayment.msg.statusFail'))
      })
    },
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateOrderPayment(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.orderPayment.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.orderPayment.msg.sortFail'))
      })
    }
  }
}
</script>
